import { render, staticRenderFns } from "./NeoparentAccess.vue?vue&type=template&id=52696776&scoped=true"
import script from "./NeoparentAccess.vue?vue&type=script&lang=js"
export * from "./NeoparentAccess.vue?vue&type=script&lang=js"
import style0 from "./NeoparentAccess.vue?vue&type=style&index=0&id=52696776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52696776",
  null
  
)

export default component.exports